module.exports = __webpack_public_path__ + "static/media/paypal_logo.0e6c231d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/paypal_logo.png
// module id = 579
// module chunks = 0